export default "__VITE_ASSET__DRy7WJYc__"